module.exports = __webpack_public_path__ + "static/media/money3.83e1c7c7.jpg";